import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to 'Checkbox' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Checkbox} from '@wandb/weave/components/Checkbox/Checkbox';
import React from 'react';

import {privacyPolicy, termsOfService} from '../../../util/urls';
import * as S from './TermsAndPrivacyCheckbox.styles';

export const TermsAndPrivacyCheckbox = ({
  isTermsChecked,
  setIsTermsChecked,
}: {
  isTermsChecked: boolean;
  setIsTermsChecked: (checked: boolean) => void;
}) => (
  <S.TermsAndPrivacyContainer>
    <Checkbox
      style={{margin: 12}}
      checked={isTermsChecked}
      onClick={() => {
        setIsTermsChecked(!isTermsChecked);
      }}
    />
    <span>
      I agree to the{' '}
      <TargetBlank href={termsOfService()}>
        <u>Terms of Service</u>
      </TargetBlank>{' '}
      and{' '}
      <TargetBlank href={privacyPolicy()}>
        <u>Privacy Policy</u>
      </TargetBlank>
      .
    </span>
  </S.TermsAndPrivacyContainer>
);
